import React from 'react'
import BlogPost from './BlogPost'

export default function BeforeThirty() {
  return (
    <BlogPost
      translationKey="beforeThirty"
      seoTitle="서른을 앞두고 | Hyunjin Jae"
      seoDescription="서른을 앞두고 느끼는 생각과 감정을 담은 글입니다."
      seoKeywords="서른, 인생, 성장, 회고, reflection, thirty, life"
      seoTags={['reflection', 'life', 'personal growth']}
    />
  )
}

